import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { checkIfFieldDisabled, composed_alignmentOptions, composed_colorOptions, composed_fontOptions, composed_horizontalAlignmentOptions, composed_paddingOptions, composed_verticalAlignmentOptions, deepCopy } from 'na-lib';
import { Validators } from '@angular/forms';

@Component({
    selector: 'app-composed-edit-content-dialog',
    templateUrl: './composed-edit-content-dialog.component.html',
    styleUrls: ['./composed-edit-content-dialog.component.css'],
    standalone: false
})
export class ComposedEditContentDialogComponent {
  contentData:any
  contentDialogForm!:FormGroup
  oldData:any
  contentTitle:string
  contentDataType:any
  nodeAttributes:any = {}
  fontOptions = composed_fontOptions
  colorOptions = composed_colorOptions
  paddingOptions = composed_paddingOptions
  horizontalAlignmentOptions = composed_horizontalAlignmentOptions
  verticalAlignmentOptions = composed_verticalAlignmentOptions
  alignmentOptions = composed_alignmentOptions
  disableTranslateField=true
  translateMode = false
  translateModeOriginal = false
  urlRegex = /^(?:\$\{[A-Za-z0-9._:-]+\}|#\S+|child:[^\s]+|dpp:\/\/main|(?:https?:\/\/|context:\/\/|pass:\/\/|content:\/\/|task:\/\/|tridy:\/\/)\S+)$/;
  urlRegexDoc = /^(?:\$\{[^}]+\}|pass:\/\/[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+)$/;

  constructor(public dialogRef: MatDialogRef<ComposedEditContentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private fb: FormBuilder){
      dialogRef.disableClose=true
  }

  ngOnInit(): void {
    this.contentDialogForm = this.fb.group({})

    this.contentData = deepCopy(this.data?.values)
    this.nodeAttributes = this.contentData?.attributes ?? {}

    this.contentDataType = this.contentData.type
    this.oldData = deepCopy(this.data?.values)
    this.contentTitle = this.data?.title

    this.translateMode = this.data?.translate ?? false
    this.translateModeOriginal = this.data?.translateOriginal ?? false

    const {fields, translationMode, translateOriginal} = this.data
    const { text, url, font, fontSize, spacing, padding, horizontalAlignment, verticalAlignment, alignment, width, height, aspectRatio,
      cornerRadius, radius, foregroundColor, backgroundColor, fillColor, strokeColor, color} = this.nodeAttributes

    if(this.translateMode){
      this.contentDialogForm = this.fb.group({
        text:[{value: text ? text:undefined, disabled: checkIfFieldDisabled('content.attributes.text', fields, this.translateModeOriginal )}],
        url: [
          { value: url ? url : undefined, disabled: false },
          [Validators.pattern(this.urlRegex)]
        ],
        font:[{value: font ? font: undefined, disabled: checkIfFieldDisabled('font',fields, this.translateModeOriginal )}], /// *******plain, bold, italic, title, subtitle
        fontSize: [{value: fontSize ? fontSize: undefined, disabled:checkIfFieldDisabled('fontSize',fields, this.translateModeOriginal )}], // in pt
        spacing: [{value: spacing ? spacing: undefined, disabled:checkIfFieldDisabled('spacing', fields, this.translateModeOriginal)}], // in pt/dp
        padding: [{value: padding ? padding: undefined, disabled:checkIfFieldDisabled('padding',fields, this.translateModeOriginal)}], // {top, leading, trailing, bottom : float}
        horizontalAlignment: [{value: horizontalAlignment ?  horizontalAlignment:undefined, disabled:checkIfFieldDisabled('horizontalAlignment',fields, this.translateModeOriginal)}], // leading, center, trailing
        verticalAlignment: [{value: verticalAlignment ? verticalAlignment: undefined, disabled:checkIfFieldDisabled('verticalAlignment', fields, this.translateModeOriginal)}], // top, center, bottom
        alignment: [{value: alignment ? alignment: undefined, disabled:checkIfFieldDisabled('alignment',fields, this.translateModeOriginal )}], // topLeading, topCenter, topTrailing
        width: [{value: width ? width: undefined, disabled:checkIfFieldDisabled('width', fields, this.translateModeOriginal )}],
        height: [{value: height ? height: undefined, disabled:checkIfFieldDisabled('height', fields, this.translateModeOriginal )}],
        aspectRatio: [{value: aspectRatio ? aspectRatio : undefined, disabled:checkIfFieldDisabled('aspectRatio', fields, this.translateModeOriginal )}],
        cornerRadius: [{value: cornerRadius ? cornerRadius : undefined, disabled:checkIfFieldDisabled('cornerRadius', fields, this.translateModeOriginal)}],
        radius: [{value: radius ? radius :undefined, disabled:checkIfFieldDisabled('radius', fields, this.translateModeOriginal)}],
        foregroundColor: [{value: foregroundColor ? foregroundColor: undefined, disabled:checkIfFieldDisabled('foregroundColor', fields, this.translateModeOriginal )}],
        backgroundColor: [{value: backgroundColor ? backgroundColor :undefined, disabled:checkIfFieldDisabled('backgroundColor', fields, this.translateModeOriginal)}],
        fillColor: [{value: fillColor ? fillColor :undefined, disabled:checkIfFieldDisabled('fillColor', fields, this.translateModeOriginal)}],
        strokeColor: [{value: strokeColor ? strokeColor: undefined, disabled:checkIfFieldDisabled('strokeColor', fields, this.translateModeOriginal )}],
        color: [{value: color? color: undefined, disabled: checkIfFieldDisabled('color',fields, this.translateModeOriginal )}],
      })
    }else{
      this.contentDialogForm = this.fb.group({
        text:[{value: text ? text:undefined, disabled: false}],//*text
        url: [
          { value: url ? url : undefined, disabled: false },
          [Validators.pattern(this.urlRegex)]
        ],//*image
        font:[{value: font ? font: undefined, disabled: false}], /// *******plain, bold, italic, title, subtitle
        fontSize: [{value: fontSize ? fontSize: undefined, disabled:false}], // in pt
        spacing: [{value: spacing ? spacing: undefined, disabled: false}], // in pt/dp
        padding: [{value: padding ? padding: undefined, disabled: false}], // {top, leading, trailing, bottom : float}
        horizontalAlignment: [{value: horizontalAlignment ?  horizontalAlignment:undefined, disabled: false}], // leading, center, trailing
        verticalAlignment: [{value: verticalAlignment ? verticalAlignment: undefined, disabled: false}], // top, center, bottom
        alignment: [{value: alignment ? alignment: undefined, disabled: false}], // topLeading, topCenter, topTrailing
        width: [{value: width ? width: undefined, disabled: false}],
        height: [{value: height ? height: undefined, disabled: false}],
        aspectRatio: [{value: aspectRatio ? aspectRatio : undefined, disabled: false}],
        cornerRadius: [{value: cornerRadius ? cornerRadius : undefined, disabled: false}],
        radius: [{value: radius ? radius :undefined, disabled: false}],
        foregroundColor: [{value: foregroundColor ? foregroundColor: undefined, disabled: false}],
        backgroundColor: [{value: backgroundColor ? backgroundColor :undefined, disabled: false}],
        fillColor: [{value: fillColor ? fillColor :undefined, disabled: false}],
        strokeColor: [{value: strokeColor ? strokeColor: undefined, disabled: false}],
        color: [{value: color? color: undefined, disabled: false}],
      })
    }
  }

  getFormatedDataAttributes(type, data){
    switch(type){
      case 'text':{
        return  { 
                  text: data.text ? data.text : undefined,
                  font: data.font ? data.font : undefined, 
                  width: data.width ? data.width : undefined, 
                  height: data.height ? data.height : undefined 
                }
      }

      case 'image':{
        return  { 
                  url: data.url ? data.url : undefined,
                  width: data.width ? data.width : undefined,
                  height: data.height ? data.height : undefined
                }      
      }
      case 'hstack':{
        return  { 
                  verticalAlignment: data.verticalAlignment ? data.verticalAlignment : undefined,
                  spacing: data.spacing ? data.spacing : undefined, 
                  width: data.width ? data.width : undefined, 
                  height: data.height ? data.height : undefined 
                }      
      }

      case 'vstack':{
        return  { 
                  horizontalAlignment: data.horizontalAlignment ? data.horizontalAlignment : undefined,
                  spacing: data.spacing ? data.spacing : undefined, 
                  width: data.width ? data.width : undefined, 
                  height: data.height ? data.height : undefined 
                }     
      }
      case 'zstack':{
        return  { 
                  width: data.width ? data.width : undefined, 
                  height: data.height ? data.height : undefined 
                }      
      }

      case 'circle':{
        return  {
                  width: data.width ? data.width : undefined, 
                  height: data.height ? data.height : undefined 
                }      
      }

      case 'rectangle':{
        return  { 
                  width: data.width ? data.width : undefined, 
                  height: data.height ? data.height : undefined 
                }      
      }
      default: 
        return {}
    }
  }

  onSave(){
    this.dialogRef.close([true, this.getFormatedDataAttributes(this.contentData.type, this.contentDialogForm.value)])
  }

}
